import React from 'react'
import {useState} from 'react'
import Footer from './Footer'
import Review from './Review'

export default function Cartracker() {
  const [fullname, setFullName] = useState('');
  const [contact, setContact] = useState('');
  const [email, setEmail] = useState('');
  const [city, setCity] = useState('');
  const [vehicledetails, setVehicleDetails] = useState('');


  const handleSubmit = async (event) => {
    event.preventDefault();

    const BASE_URL = 'https://node.insuranceadvisors.pk';
    const orderData = { fullname , email, city, contact, vehicledetails };

    try {
      // Save order data to the backend
      const saveResponse =await fetch(`${BASE_URL}/api/cartracker`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(orderData),
      });

      if (saveResponse.ok) {
        // Send email with the saved order data
        const emailResponse =  await fetch(`${BASE_URL}/api/sendTrackerEmail`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(orderData),
        });

        if (emailResponse.ok) {
          alert('Order placed and email sent successfully!');
          window.location.href = '/our';
        } else {
          console.error('Failed to send email:', emailResponse.statusText);
        }
      } else {
        console.error('Failed to submit data:', saveResponse.statusText);
      }
    } catch (error) {
      console.error('Error submitting data:', error);
    }
  };

  return (
    <div>

{/* *********************   first section START HERE ***************  */}

       {/* <div class="col">
      Column
    </div> */}
      
      <div class="container" >
  <div class="row">
    
    <div class="col-sm-6 order-1 order-sm-1">
      <br/><br/>
      <h2 className='position-relative tracker1 data-aos-delay="500'>
      Track and manage your Car from today...
      </h2> 
      <p className='tracker2'>
       We provide the following services:-  
    <ul>
        <li><strong>Location Tracking:</strong> Real-time GPS tracking for accurate vehicle positioning.</li>
        <li><strong>Apps available for Tracking:</strong> User-friendly apps for iOS and Android to monitor vehicles on-the-go.</li>
        <li><strong>Geo-Fencing:</strong> Set up virtual boundaries and receive instant alerts when vehicles enter or exit designated zones.</li>
        <li><strong>Route Optimization:</strong> Plan the most efficient routes to save time and reduce fuel consumption.</li>
        <li><strong>Fuel Monitoring:</strong> Track fuel usage and improve vehicle efficiency.</li>
        <li><strong>Driver Behavior Analysis:</strong> Monitor speeding, hard braking, and other behaviors to ensure safe driving.</li>
        <li><strong>Maintenance Alerts:</strong> Receive proactive alerts for vehicle servicing and maintenance to reduce downtime.</li>
        <li><strong>Real-Time Notifications:</strong> Get instant alerts on vehicle movements, irregularities, and safety concerns.</li>
        <li><strong>Historical Data Reports:</strong> Analyze past routes, stops, and performance to improve future planning.</li>
        <li><strong>Safety Features:</strong> Include panic buttons, SOS alerts, and emergency response options for enhanced security.</li>
        <li><strong>Customizable Reporting:</strong> Generate detailed reports based on your tracking needs (e.g., location, speed, distance).</li>
        <li><strong>Security Monitoring:</strong> Track vehicle health, theft prevention, and safety protocols to ensure the security of your fleet.</li>
    </ul>
</p>

    </div>

    <div class="col-sm-6 order-0 order-sm-1">
      
   <div className="card-heading">
     <h1 className="title">Car Tracker Form</h1>
        <p id='p_1'> Are you concerned about tracking your Car?  </p>
      </div>
    <div className="card-body">

    <form onSubmit={handleSubmit}>

        <div className="form-row">
         <div className="name">Full name</div>
          <div className="value">
            <input className="input--style-6" type="text" name="fullname" value={fullname} onChange={(e) => setFullName(e.target.value)} placeholder='Enter your Full Name'/>
     </div>
    </div>
      
  <div className="form-row">
    <div className="name">Email address</div>
    <div className="value">
   <div className="input-group">
    <input className="input--style-6" type="email" name="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="example@email.com"/>
    </div>
    </div>
     </div>
      <div className="form-row">
        <div className="name">Contact Number</div>
          <div className="value">
             <div className="input-group">
              <input className="input--style-6" type="number" name="contact" value={contact} onChange={(e) => setContact(e.target.value)} placeholder="03**-*******"/>
                 </div>
                </div>
                </div>
                <div className="form-row">
   <div className="name">Enter Your City</div>
    <div className="value">
     <input className="input--style-6" type="text" name="city" value={city} onChange={(e) => setCity(e.target.value)} placeholder='Enter your City Name'/>
     </div>
    </div>


  <div className="form-row">
    <div className="name">Vehicle Details</div>
    <div className="value">
    <div className="input-group">
    <textarea className="textarea--style-6" name="vehicledetails" value={vehicledetails} onChange={(e) => setVehicleDetails(e.target.value)} placeholder="Please type your Vehicles Details"></textarea>
      </div>
      </div>
      </div>
<br/>
<div className="cl1">
     <button className="btn btn-danger" type="submit" > SUBMIT </button>
 </div>
</form></div>
   </div>
  </div>
</div>

<br/><br/>

{/* *****************    First section END HERE  ******************/}




{/* ***********   second section STARTS HERE ******************* */}

<Review> </Review>

{/* <div class="container-fluid"id='jk'>
  <br/><br/><br/><br/><br/>
  <div class="row">
    <div class="col">
 <h2 className='cl4'> Our team will contact you soon </h2>
 <br/><br/><br/><br/>
    </div>
 
  </div>
</div> */}

{/* ************** second section ENDS HERE ******************** */}

<br/><br/><br/><br/>
<Footer></Footer>

    </div>
  )
}
